module.exports = __webpack_public_path__ + "images/ai_recommendations/brief-7c3e8eb232f18c610b090d40d7fe4afc.svg";